import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconHome = props => (
  <SvgIcon {...props} viewBox="0 0 19.999998 16.799999">
    <polygon points="22 12 12 3 2 12 5 12 5 20 10 20 10 14 14 14 14 20 19 20 19 12" transform="translate(-2,-3)" />
  </SvgIcon>
);

export default IconHome;



// WEBPACK FOOTER //
// ./src/components/icons/IconHome.js